export function preloadImage(src: string): void {
    let img = new Image();
    img.src = src;
}
